import '../styles/Grille.css';
import { useTranslation } from 'react-i18next';

function Grille({rows, rowsUpdate, gameNow}) {
    const { t } = useTranslation();
    console.log('rows', rows, 'gameNow', gameNow)

    const anyDevMatch = (devs1, devs2) => {
        return devs2.some(dev => devs1.includes(dev));
    };

    const allDevsMatch = (devs1, devs2) => {
        return devs1.every(dev => devs2.includes(dev));
    };

    const extraDevsInSecond = (devs1, devs2) => {
        return devs1.every(dev => devs2.includes(dev)) && devs2.some(dev => !devs1.includes(dev));
    };

    function parseDevs(value) {
        return value ? (value.includes(',') ? value.split(',').map(dev => dev.trim()) : [value.trim()]) : null;
    }

    return (
		<div className="grille">
            <div className="grille-row grille-row-head">
                <div className="grille-col">{t('grillegame.game')}</div>
                <div className="grille-col">{t('grillegame.year')}</div>
                <div className="grille-col">{t('grillegame.platform')}</div>
                <div className="grille-col">{t('grillegame.sales')}</div>
                <div className="grille-col">{t('grillegame.note')}</div>
                <div className="grille-col">{t('grillegame.type')}</div>
                <div className="grille-col">{t('grillegame.dev')}</div>
            </div>
            {rows.map(({ rowsLength, id_jeu, nom_jeu, annee_jeu, plateforme_jeu, nb_vente_jeu, note_jeu, type_jeu, dev_jeu, img_jeu }) => {
                // on test si nb_vente_jeu est egale à "Unknown" si oui on le mets égal à 0, sinon on le convertir en float
                const nb_vente_jeu_conv = (nb_vente_jeu === 'Unknown' ? 0 : parseFloat(nb_vente_jeu))
                // on test si nb_vente_jeu est egale à "Unknown" si oui on le mets égal à 0, sinon on le convertir en float
                const gameNow_nb_vente_jeu_conv = (gameNow.nb_vente_jeu === 'Unknown' ? 0 : parseFloat(gameNow.nb_vente_jeu))
                
                // on test si note_jeu est egale à "Tbd" si oui on le mets égal à 0, sinon on le convertir en int
                const note_jeu_conv = (note_jeu === 'Tbd' ? 0 : parseInt(note_jeu))
                // on test si note_jeu est egale à "Tbd" si oui on le mets égal à 0, sinon on le convertir en int
                const gameNow_note_jeu_conv = (gameNow.note_jeu === 'Tbd' ? 0 : parseInt(gameNow.note_jeu))

                // Conversion des developpeurs en tableaux pour gérer les parties multiples (ex: "Nintendo, Capcom")
                let devsGame = parseDevs(dev_jeu);
                let devsNow = parseDevs(gameNow.dev_jeu);
                // Vérifier si l'un des developpeurs de devsGame est dans devsNow
                let devTrouve = devsGame && devsNow ? anyDevMatch(devsNow, devsGame) : false;
                // Vérifier si tous les developpeurs de devsNow sont dans devsGame
                let tousDevsTrouves = devsGame && devsNow ? allDevsMatch(devsNow, devsGame) : false;
                // Vérifier si tous les developpeurs de devsNow sont dans devsGame et que devsGame a des developpeurs en plus
                let devsSupplementaires = devsGame && devsNow ? extraDevsInSecond(devsNow, devsGame) : false;

                return (
                    <div className="grille-row" key={rowsLength}>
                        
                        <div className={`grille-cell ${id_jeu === gameNow.id_jeu ? 'green' : 'red'}`} >
                            <div className='grille-cell-detail'>
                                <span><img src={`/images/games/${img_jeu}`} alt={nom_jeu} /></span><br />
                                <span>{nom_jeu}</span>
                            </div>
                        </div>
                        { annee_jeu === gameNow.annee_jeu ?
                            <div className='grille-cell green'>{annee_jeu}</div>
                            : annee_jeu < gameNow.annee_jeu ? 
                                <div className='grille-cell red after'>{annee_jeu} <img src='/images/assets/arrow_up.png' alt='arrow_up' /></div>
                                : <div className='grille-cell red before'>{annee_jeu} <img src='/images/assets/arrow_down.png' alt='arrow_down' /></div>
                        }
                        <div className={`grille-cell ${plateforme_jeu === gameNow.plateforme_jeu ? 'green' : 'red'}`} >{plateforme_jeu}</div>
                        { 
                            

                            nb_vente_jeu_conv === gameNow_nb_vente_jeu_conv ?
                                <div className='grille-cell green'>{nb_vente_jeu}</div>
                            // : nb_vente_jeu_conv < (gameNow.nb_vente_jeu === 'Unknown' ? 0 : gameNow.nb_vente_jeu) ? 
                            : nb_vente_jeu_conv < gameNow_nb_vente_jeu_conv ?
                                <div className='grille-cell red after'>{nb_vente_jeu} <img src='/images/assets/arrow_up.png' alt='arrow_up' /></div>
                            : <div className='grille-cell red before'>{nb_vente_jeu} <img src='/images/assets/arrow_down.png' alt='arrow_down' /></div>
                        }
                        { 
                            note_jeu_conv === gameNow_note_jeu_conv ?
                                <div className='grille-cell green'>{note_jeu}</div>
                            // : note_jeu < (gameNow.note_jeu === 'Tdb' ? 0 : gameNow.note_jeu) ? 
                            : note_jeu_conv < gameNow_note_jeu_conv ?
                                <div className='grille-cell red after'>{note_jeu} <img src='/images/assets/arrow_up.png' alt='arrow_up' /></div>
                            : <div className='grille-cell red before'>{note_jeu} <img src='/images/assets/arrow_down.png' alt='arrow_down' /></div>
                        }
                        <div className={`grille-cell ${type_jeu === gameNow.type_jeu ? 'green' : 'red'}`} >{type_jeu}</div>
                        <div className={`grille-cell ${tousDevsTrouves && !devsSupplementaires ? 'green' : devTrouve ? 'orange' : 'red'}`} >{dev_jeu}</div>
                        { /* <div className={`grille-cell ${toutesCouleursTrouvees && !couleursSupplementaires ? 'green' : couleurTrouvee ? 'orange' : 'red'}`}>{color}</div> */ }
                    </div>
                );
            })}
        </div>
	)
}

export default Grille
